// extracted by mini-css-extract-plugin
export default {"main":"layoutless_main__gLlUS"};